import api from '../index';

const baseUrl = '/subscription';

export const updateSubscriptionApi = (data) => {
  return api({
    method: 'put',
    url: `${baseUrl}/update-subscription`,
    data,
  });
};

export const getSubscriptionPlansApi = () => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-subscription-plans`,
  });
};

export const getSubscriptionApi = () => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-subscription-detailed`,
  });
};

export const getAddOnsListApi = () => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-add-ons-list`,
  });
};

export const subscribeAddOnsApi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/stripeAddOns`,
    data,
  });
};

export const retryPaymentApi = () => {
  return api({
    method: 'post',
    url: `${baseUrl}/retry-payment`,
  });
};

export const unsubscribePlanApi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/cancel-subscrption`,
    data,
  });
};

export const endTrialApi = () => {
  return api({
    method: 'post',
    url: `${baseUrl}/pay-now`,
  });
};

export const payInvoiceApi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/pay-invoice`,
    data,
  });
};

export const upgradePlanApi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/upgrade`,
    data,
  });
};

export const createSubscriptionApiPaypal = (data) => {
  return api({
    method: 'post',
    url: 'billing/create-billing-subscription',
    data,
  });
};

export const updateSubscriptionApiPaypal = (data) => {
  return api({
    method: 'put',
    url: `${baseUrl}/upgrade-paypal`,
    data,
  });
};
